/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { motion } from 'framer-motion';

const EmptyState = ({
    selectedFilter,
    isEducationDomain,
    isFlexOfficeDomain,
    isRetailDomain,
    isInstitutionDomain,
    isAssessmentDomain,
    isServicesDomain,
    isITDomain,
    documentTypeDisplay,
    emptyStateText,
    exploreButtonText,
    exploreNavigationPath,
    onSetSelectedFilter,
    onNavigate,
    domainBackgroundColor,
    domainIcon
}) => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-16 bg-white rounded-xl border border-slate-200"
        >
            <div
                className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
                style={{ backgroundColor: domainBackgroundColor }}
            >
                {domainIcon}
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-2">
                {selectedFilter === 'all'
                    ? isEducationDomain ? 'No purchase found' : `No ${documentTypeDisplay.toLowerCase()}s found`
                    : isEducationDomain ? `No ${selectedFilter} purchase found` : `No ${selectedFilter} ${documentTypeDisplay.toLowerCase()}s found`
                }
            </h3>
            <p className="text-slate-600 mb-6 max-w-md mx-auto">
                {selectedFilter === 'all'
                    ? emptyStateText
                    : isEducationDomain
                        ? `No ${selectedFilter} enrollments found.`
                        : `No ${selectedFilter} ${documentTypeDisplay.toLowerCase()}s found.`
                }
            </p>
            <div className="flex flex-wrap gap-3 justify-center px-4">
                <button
                    onClick={() => onNavigate(exploreNavigationPath)}
                    className="px-6 py-3 lg:py-2.5 text-white rounded-lg hover:opacity-90 transition-colors font-medium"
                    style={{ backgroundColor: domainBackgroundColor }}
                >
                    {exploreButtonText}
                </button>
                {selectedFilter !== 'all' && (
                    <button
                        onClick={() => onSetSelectedFilter('all')}
                        className="px-6 py-3 lg:py-2.5 bg-white border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors font-medium"
                    >
                        View All
                    </button>
                )}
            </div>
        </motion.div>
    );
};

export default EmptyState;